import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { customerService } from '@services/api/customerService';
import type { Session } from '@/types/customer';
import '../CustomerTabs.css';

interface SessionsTabProps {
  customerId: string;
}

export const SessionsTab = ({ customerId }: SessionsTabProps) => {
  const [sessions, setSessions] = useState<Session[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSessions();
  }, [customerId]);

  const loadSessions = async () => {
    const result = await customerService.getCustomerSessions(customerId);
    if (result.success && result.data) {
      setSessions(result.data);
    }
    setLoading(false);
  };

  const getSessionDuration = (startTime: string, endTime: string | null) => {
    const start = new Date(startTime);
    const end = endTime ? new Date(endTime) : new Date();
    const durationMs = end.getTime() - start.getTime();
    const minutes = Math.floor(durationMs / 60000);
    const seconds = Math.floor((durationMs % 60000) / 1000);
    
    if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    }
    return `${seconds}s`;
  };

  if (loading) return <div>Loading sessions...</div>;

  return (
    <div className="tab-content-wrapper">
      <div className="info-card">
        <h3 className="info-card-title">📱 User Sessions</h3>
        
        {sessions.length === 0 ? (
          <p className="text-secondary">No sessions found</p>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Session ID</th>
                  <th>Device</th>
                  <th>Status</th>
                  <th>Start Time</th>
                  <th>Duration</th>
                  <th>Current Page</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sessions.map((session: any) => (
                  <tr key={session.id}>
                    <td className="customer-id">#{session.id.slice(0, 8)}</td>
                    <td className="text-small">
                      {session.device?.device_name || session.device?.device_type || 'Unknown'}
                      {session.device?.os_name && (
                        <span className="text-secondary"> • {session.device.os_name}</span>
                      )}
                    </td>
                    <td>
                      <span className={`status-badge status-${
                        session.status === 'active' ? 'green' : 
                        session.status === 'ended' ? 'gray' : 'orange'
                      }`}>
                        {session.status}
                      </span>
                    </td>
                    <td className="text-small">{new Date(session.start_time).toLocaleString()}</td>
                    <td className="text-small">{getSessionDuration(session.start_time, session.end_time)}</td>
                    <td className="text-small">{session.current_page || 'N/A'}</td>
                    <td>
                      <Link 
                        to={`/customers/${customerId}/sessions/${session.id}`} 
                        className="btn btn-ghost btn-small"
                      >
                        View Details
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

